import React from 'react';
import { graphql, useFragment } from 'react-relay';
import Badge from '@atlaskit/badge';
import { SimpleTag as Tag } from '@atlaskit/tag';
import { useIntl } from '@atlassian/jira-intl';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import type { StoryPointsGroupHeader$key } from './__generated__/StoryPointsGroupHeader.graphql';
import messages from './messages.tsx';

export type Props = {
	storyPointsGroupHeader: StoryPointsGroupHeader$key | null;
};

export const StoryPointsGroupHeader = ({ storyPointsGroupHeader }: Props) => {
	const data = useFragment<StoryPointsGroupHeader$key>(
		graphql`
			fragment StoryPointsGroupHeader on JiraJqlNumberFieldValue {
				number
			}
		`,
		storyPointsGroupHeader,
	);

	const { formatMessage } = useIntl();

	return isVisualRefreshEnabled() ? (
		<Badge appearance="default">
			{typeof data?.number === 'number'
				? formatMessage(messages.storyPoints, {
						points: data?.number,
					})
				: formatMessage(messages.noStoryPoints)}
		</Badge>
	) : (
		<Tag
			text={
				typeof data?.number === 'number'
					? formatMessage(messages.storyPoints, {
							points: data?.number,
						})
					: formatMessage(messages.noStoryPoints)
			}
		/>
	);
};
